import { useState, useMemo } from 'react';
import { createModel } from 'hox';
import { message } from 'antd';
import { get } from 'lodash';

import { teaTrack } from '@src/utils/tea';
import { isMobile as mobileCheck } from '@src/utils/is';
import { path } from '../Route';
import {
    getQuestionnaireTplRequest,
    Response,
    ErrorCode
} from '@src/apps/interview-questionnaire/services/getQuestionnaireTpl';

import { QuestionnaireState } from '@src/apps/interview-questionnaire/services/model';
const useTemplate = () => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState<Response>();
    const isMobile = useMemo(() => {
        return mobileCheck();
    }, []);
    const getTemplate = (questionnaire_token: string) => {
        // 如果没有questionnaire_token，则跳转至404
        if (!questionnaire_token) {
            window.routerHistory && window.routerHistory.replace(path[404]);
            return;
        }
        setLoading(true);
        getQuestionnaireTplRequest({ questionnaire_token })
            .then((data) => {
                const { questionnaire_state, biz_modify_time, tenant_id } = data;
                window.tenant_id = tenant_id;
                const { replace } = window.routerHistory;
                setLoading(false);
                setData(data);

                if (questionnaire_state === QuestionnaireState.FeedBack) {
                    // 如果已经提交
                    teaTrack('atsx_satisfaction_questionnairee_filledpage', {
                        tenant_id,
                        channel: isMobile ? 'mobile' : 'PC'
                    });
                    replace(path.hasSubmitted(questionnaire_token), {
                        last_submit_time: biz_modify_time
                    });
                } else if (questionnaire_state === QuestionnaireState.Invalid) {
                    // 如果问卷失效
                    teaTrack('atsx_satisfaction_questionnairee_invalidationpage', {
                        tenant_id,
                        channel: isMobile ? 'mobile' : 'PC'
                    });
                    replace(path.expired(questionnaire_token));
                } else {
                    teaTrack('atsx_satisfaction_questionnairee_open', {
                        tenant_id,
                        channel: isMobile ? 'mobile' : 'PC'
                    });
                    replace(path.detail(questionnaire_token));
                }
            })
            .catch((error) => {
                const code = get(error, 'code');
                const { replace } = window.routerHistory;
                if (code === ErrorCode.ParseError) {
                    replace(path[404]);
                }
                const msg = error?.message || error?.msg || '';
                msg && message.error(error?.message || error?.msg || '');
            });
    };

    return { loading, data, getTemplate };
};

export default createModel(useTemplate);
